import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/shared/services/setting.service';
import { finalize } from 'rxjs/operators';
import { IStoreMenuItem, IStoreMenuCategoryItem, ITranslatableText } from './store.service';
import { ImageService } from 'src/app/shared/services/image.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';



export interface IItemCategories{
  id: string;
  name: ITranslatableText
}
export interface IItemSubCategories {

}

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  itemCategories: IItemCategories[]=[];
  itemSubCategories: any[]=[];
  constructor(
    private http: HttpClient, 
    private settingService: SettingService,
    private imageService: ImageService,
    private apiController: ApiControllerService
  ) { }

  validateThirdPartyQuantities(storeId: string, itemCode: string, quantities: number)
  {
      return Observable.create(o => {
        /* this.http.post(this.settingService.apiUrl('Item/ValidateThirdPartyQuantities'),
        {          
            storeId: storeId,
            itemCode: itemCode,
            quantity: quantities
        })
        .pipe(finalize(()=>{
          o.complete();
        }))
        .subscribe((res: boolean)=>{
          o.next(res);
        }) */

        this.apiController.post(this.settingService.apiUrl('Item/ValidateThirdPartyQuantities'),
        {          
            storeId: storeId,
            itemCode: itemCode,
            quantity: quantities
        })
        .pipe(finalize(()=>{
          o.complete();
        }))
        .subscribe((res: boolean)=>{
          o.next(res);
        })
      })
  }

  getSpecificMenuItem(itemId: string, merchantId: string)
  {

      return Observable.create(o=>{
        /* this.http.post(this.settingService.apiUrl('Menu/GetMenuItem'),
        {          
            itemId: itemId,
            merchantId: merchantId
        })
        //.subscribe((data: IStoreMenuItem) => {
        .subscribe((data: IStoreMenuCategoryItem) => {
          //console.log(data);
          o.next(data);
        }) */

        this.apiController.post(this.settingService.apiUrl('Menu/GetMenuItem'),
        {          
            itemId: itemId,
            merchantId: merchantId
        })
        //.subscribe((data: IStoreMenuItem) => {
        .subscribe((data: IStoreMenuCategoryItem) => {
          //console.log(data);
          o.next(data);
        })
      })
  }

  getStoresWithSpecificItem(itemId: string, merchantId: string, externalProviderType?: number)
  {

      return Observable.create(o=>{
        /* this.http.post(this.settingService.apiUrl('/Menu/GetStoresWithSpecificItem'),
        {          
            itemId: itemId,
            merchantId: merchantId,
            externalProviderType: externalProviderType
        })
        //.subscribe((data: IStoreMenuItem) => {
        .subscribe((data: IStoreMenuCategoryItem) => {
          o.next(data);
        }) */

        this.apiController.post(this.settingService.apiUrl('/Menu/GetStoresWithSpecificItem'),
        {          
            itemId: itemId,
            merchantId: merchantId,
            externalProviderType: externalProviderType
        })
        //.subscribe((data: IStoreMenuItem) => {
        .subscribe((data: IStoreMenuCategoryItem) => {
          o.next(data);
        })
      })
  }
}